import { Navigate, Outlet, useLocation } from 'react-router';

import { AppLayout } from 'AppLayout';
import { LoginState, useSelectLoginState } from 'Auth/data';
import { urls } from 'Router/urls';

export const RequireAuth = () => {
  const location = useLocation();
  const loginState = useSelectLoginState();

  if (
    loginState === LoginState.NOT_LOGGED ||
    loginState === LoginState.LOGIN_REJECTED ||
    loginState === LoginState.LOGGING_OUT
  ) {
    return <Navigate to={urls.loginPage} state={{ from: location }} replace />;
  }

  return (
    <AppLayout isForLogged>
      <Outlet />
    </AppLayout>
  );
};
